import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';
import { WorkflowView } from 'cb-model';

export const WorkflowUserReport = (): React.JSX.Element => {
  const initialQueryOptions = useInstitutionFilter({
    where: {
      and: [
        { fieldId: 'institution_id', operator: 'eq', value: '', display: 'hidden' },
        { fieldId: 'assigned_to', operator: 'eq', value: '' },
        { fieldId: 'root_id', operator: 'eq', value: '' },
      ],
    },
  });
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(WorkflowView, initialQueryOptions);
  const gCacheQueryItem = useCacheQuery(WorkflowView, queryOptions);

  return (
    <Section>
      <PaginatorAndListSettings
        entity={WorkflowView}
        gCacheQuery={gCacheQueryItem}
        queryOptions={queryOptions}
        render={Search}
        setQueryOptions={setQueryOptions}
      />
    </Section>
  );
};
